import { useEffect, useState } from 'react';
import ApiService from '../services/ApiService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ProgressBar = ({ percentage, color = '#17a2b8', label }) => {
    const width = Math.min(100, Math.max(0, percentage)); // Asegura que esté entre 0 y 100
    return (
        <div style={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
            {/* Barra */}
            <div style={{
                flexGrow: 1,
                backgroundColor: '#e9ecef',
                borderRadius: '0.25rem',
                height: '25px',
                overflow: 'hidden',
                marginRight: '10px'
            }}>
                <div style={{
                    width: `${width}%`,
                    backgroundColor: color,
                    height: '100%',
                    transition: 'width 0.5s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingRight: '5px',
                    color: width > 15 ? 'white' : 'black', // Asegura legibilidad
                    fontSize: '0.85rem',
                    fontWeight: 'bold'
                }}>
                    {label}
                </div>
            </div>
        </div>
    );
};


export default function TopEquipos({ jornadas, survivorId }) {
    const [selectedJornada, setSelectedJornada] = useState(null);
    const [equipos, setEquipos] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchEquipos = async (idJornada) => { // Cambiado a idJornada
        setLoading(true);
        try {
            const res = await ApiService.get(`/leaderboard/top-equipos?filtronumerojornada=${idJornada}&survivorId=${survivorId}`);
            setEquipos(res.topEquipos || []);
        } catch (error) {
            console.error('Error al cargar equipos:', error);
            setEquipos([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedJornada) {
            fetchEquipos(selectedJornada);
        }
    }, [selectedJornada, survivorId]);

    useEffect(() => {
        if (jornadas.length > 0 && !selectedJornada) {
            // Selecciona el ID de la primera jornada
            setSelectedJornada(jornadas[0].id);
        }
    }, [jornadas]);

    // Filtrar jornadas únicas
    const jornadasUnicas = jornadas.filter(
        (j, index, self) =>
            index === self.findIndex((o) => o.numero === j.numero && o.nombre === j.nombre)
    );

    return (
        <div className="card shadow h-100 mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className="m-0 font-weight-bold textos">Ranking de Equipos Seleccionados</h6>
                <select
                    className="form-select w-auto"
                    value={selectedJornada || ''}
                    onChange={(e) => setSelectedJornada(Number(e.target.value))}
                >
                    <option value="" disabled>Selecciona una jornada</option>
                    {jornadasUnicas.map((j) => (
                        <option key={j.id} value={j.id}>
                            Jornada {j.numero} - {j.nombre}
                        </option>
                    ))}
                </select>
            </div>

            <div className="card-body">
                {loading ? (
                    // Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} height={50} />)
                    <p className="text-center">Cargando datos...</p>
                ) : equipos.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: '10%' }}>Equipo</th>
                                    <th style={{ width: '50%' }}>Gráfico de Porcentaje</th>
                                    <th className="text-center" style={{ width: '20%' }}>% de Jornada</th>
                                    <th className="text-center" style={{ width: '20%' }}># Selecciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {equipos.map((equipo, i) => {
                                    const porcentajeJornada = parseFloat(equipo.porcentaje_selecciones_jornada).toFixed(1);
                                    const porcentajeTiempo = parseFloat(equipo.porcentaje_tiempo_seleccionado).toFixed(1);

                                    // Determinar el color base
                                    let equipoColor;

                                    // Verificar si porcentajeJornada es '0.0' (como string)
                                    if (porcentajeJornada === '0.0') {
                                        equipoColor = '#e9ecef';
                                    } else {
                                        // Si no es '0.0', usar el color definido o el predeterminado
                                        equipoColor = equipo.color_hex || '#14b624';
                                    }
                                    return (
                                        <tr key={i}>
                                            {/* Columna 1: Equipo y Logo */}
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={'https://aicapitan.com/Survivor/admin/controllers/' + equipo.logo_url}
                                                        alt={equipo.nombre_equipo}
                                                        style={{ height: 30, width: 30, objectFit: 'contain', marginRight: 10 }}
                                                    />
                                                    <span className="textos fw-bold">{equipo.nombre_equipo}</span>
                                                </div>
                                            </td>

                                            {/* Columna 2: Gráfico de Porcentaje */}
                                            <td>
                                                <ProgressBar
                                                    percentage={porcentajeJornada}
                                                    color={equipoColor} // Usar el color del equipo si existe
                                                    //label={`${porcentajeJornada}%`}
                                                />
                                            </td>

                                            {/* Columna 3: % de Tiempo Seleccionado (Histórico) */}
                                            <td className="text-center">
                                                <span className="badge bg-secondary">
                                                    {porcentajeJornada}%
                                                </span>
                                            </td>

                                            {/* Columna 4: Número de Selecciones (Picks) en la Jornada */}
                                            <td className="text-center">
                                                <span className="badge bg-dark">
                                                    {equipo.total_selecciones_equipo_jornada} picks
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-center">No hay datos de selecciones para esta jornada.</p>
                )}
            </div>
        </div>
    );
}